import { doc, getDoc } from 'firebase/firestore';
import { db } from '../shared/api/firebase/config';
import { FIREBASE_CONFIG } from '../config/Config';

const appId = FIREBASE_CONFIG.projectId;

export async function fetchUserPlan(uid) {
  const userRef = doc(db, 'artifacts', appId, 'users', uid, 'profile', 'data');
  const snap = await getDoc(userRef);
  if (snap.exists()) {
    const data = snap.data();
    return { plan: data.plan, role: data.role };
  }
  return null;
}
